export default __webpack_public_path__ + "static/media/interface-8.ce97e908.png";